<!-- Navigation -->
<nav class="navbar navbar-expand-lg navbar-light fixed-top" id="landing-mainNav">
  <div class="container">
    <a href="https://www.iata.org/services/finance/bsp/Pages/global-net-remit-5-nr5.aspx" id="landing-iataHyperlink" target="_blank">
      <div class="navbar-nr5-brand iata-logo" id="landing-iata"></div>
    </a>
  </div>
</nav>
<!-- Intro Header -->
<header class="masthead">
  <div class="intro-body d-flex align-items-center justify-content-center">
    <div class="container text-center">
      <div class="row">
        <div class="col-3"></div>
        <div class="col-6 alert alert-error w-50" div="browserMessageSection" *ngIf="browserMessage">
          <small class="alert-danger" id="landing-browserMessageText">
            <span class="text-danger" id="landing-browserMessage"> {{ browserMessage | translate }} </span>
          </small>
        </div>
      </div>
      <div class="row">
        <div class="col-8 mx-auto">
          <b id="landing-welcome" class="welcome" translate> Welcome </b>
          <img id="landing-gnr5" src="assets/landing/img/Artboard 1.png" class="nr5-img">
        </div>
      </div>
      <div class="row">
        <div class="col-6 mx-auto">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</header>

<app-foot></app-foot>
